import { inject, Injectable, signal } from '@angular/core';
import { IWorkflow } from "../../../interfaces/i-workflow";
import { IInstructions } from "../../../interfaces/i-instructions";
import { ProfileService } from "../../../../../services/profile.service";

@Injectable({ providedIn: 'root' })
export class WorkflowBuilderService {
  workflow = signal<Partial<IWorkflow>>({});
  instructions = signal<IInstructions[]>([]);

  #profileService = inject(ProfileService);

  /** Resets workflow state to empty defaults. Call this when the builder component is destroyed. */
  resetWorkflow(): void {
    this.workflow.set({});
    this.instructions.set([]);
  }

  setDefaultSecurityAndAdminValues() {
    const currentWorkflow = this.workflow();
    const userProfile = this.#profileService.userProfile();
    const currentUser = {
      userId: userProfile?.profile.email || '',
      name: userProfile?.profile.name || '',
    };

    // Set default values for security and admin properties if they are not set
    this.workflow.update(current => ({
      ...current,
      details: {
        ...current.details,
        name: current.details!.name,
        description: current.details!.description,
        isEnabled: typeof current.details!.isEnabled === 'undefined' ? true : current.details!.isEnabled,
        isUniversal: typeof current.details!.isUniversal === 'undefined' ? false : current.details!.isUniversal,
        sensitivityLabels: current.details!.sensitivityLabels,
        owners: [currentUser]
      }
    }));
  }
}
